module.exports = __webpack_public_path__ + "static/img/vh-saas-color-Video.2c2b4f55.png";